export enum ESorterOrder {
  NORMAL = 'normal',
  DESC = 'desc',
  ASC = 'asc',
}

export enum ESorterType {
  NAME,
  EVENT,
}

export interface ISorterOrderWithType {
  sorterOrder: ESorterOrder;
  type: ESorterType;
}

export interface IHeader {
  loading?: boolean;
  openNameSort?: boolean;
  count?: number;
  onClick?: (value: ISorterOrderWithType) => void;
  showTotal?: boolean;
}
